import React, { Component } from "react";
import Icon from "../../Common/Icon";

export default class Submit extends Component {
  render() {
    const { config = {}, isSubmitting, handleClick, disabled } = this.props;

    return (
      <button
        type="button"
        className={`btn btn--align-right btn--in-form ${config.class || ""} 
          ${disabled ? "btn--disabled" : ""}
          ${isSubmitting ? "btn--disabled btn--loading" : ""}`}
        disabled={disabled || isSubmitting}
        onClick={handleClick}
      >
        {config.label || "Submit"}
        <Icon className="btn__icon btn__icon--right" iconName="arrow-right" />
        <Icon
          className="btn__icon btn__icon--loading"
          iconName="loading-dark"
        />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Form/Submit.js